// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export interface GeoLocation {
    lat: number;
    lng: number;
    status?: "success" | "failed";
}

export const getGeoLocation = (defaultLocation: GeoLocation) =>
    new Promise<GeoLocation>((resolve, _) => {
        if (!navigator.geolocation) {
            return resolve(defaultLocation);
        }

        navigator.geolocation.getCurrentPosition(
            (position: GeolocationPosition) => {
                resolve({
                    lat: parseFloat(`${position.coords.latitude}`),
                    lng: parseFloat(`${position.coords.longitude}`),
                    status: "success",
                });
            },
            (_: any) => {
                resolve({ ...defaultLocation, status: "failed" });
            },
            { timeout: 5500 },
        );
    });
